var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C77.6139 0 100 22.3861 100 50C100 77.6139 77.6139 100 50 100C22.3861 100 0 77.6139 0 50C0 22.3861 22.3861 0 50 0Z",
    fill: "#0052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0218 67.5706C40.3038 67.5706 32.4513 59.6964 32.4513 50.0001C32.4513 40.3038 40.3255 32.4296 50.0218 32.4296C58.7203 32.4296 65.9437 38.7637 67.332 47.0717H85.0326C83.5359 29.024 68.4383 14.8374 50.0001 14.8374C30.5858 14.8374 14.8374 30.5858 14.8374 50.0001C14.8374 69.4144 30.5858 85.1628 50.0001 85.1628C68.4383 85.1628 83.5359 70.9762 85.0326 52.9285H67.3103C65.922 61.2365 58.7203 67.5706 50.0218 67.5706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbase);
export default __webpack_public_path__ + "static/media/Coinbase.2986d3be8740a846d477941795ebbe7b.svg";
export { ForwardRef as ReactComponent };